(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbd-digital-cross-sell"] && !Shopify.designMode) return;
  try {
    
function initPbdCrossSell(root){if(root.dataset.auto!=='true'||root.dataset.ready)return;root.dataset.ready='true';const load=async()=>{try{const url=new URL(root.dataset.url,window.location.origin);const themeId=new URL(window.location.href).searchParams.get('preview_theme_id');if(themeId)url.searchParams.set('preview_theme_id',themeId);const response=await fetch(url);if(!response.ok)return;const html=new DOMParser().parseFromString(await response.text(),'text/html');const fresh=html.querySelector('[data-pbd-cross-sell]');if(fresh&&fresh.querySelector('.pbd-cross-card'))root.innerHTML=fresh.innerHTML;}catch{}};if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();load();}},{rootMargin:'300px'});observer.observe(root);}else load();}
document.querySelectorAll('[data-pbd-cross-sell]').forEach(initPbdCrossSell);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-pbd-cross-sell]').forEach(initPbdCrossSell));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbd-digital-product"] && !Shopify.designMode) return;
  try {
    
function initPbdDigital(root){if(root.dataset.ready)return;root.dataset.ready='true';const select=root.querySelector('[data-pbd-variant]');const button=root.querySelector('[data-pbd-add]');if(select&&button){select.addEventListener('change',()=>{const option=select.selectedOptions[0];root.querySelector('[data-pbd-price]').textContent=option.dataset.price;button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.unavailable:button.dataset.label;const url=new URL(window.location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);});}root.querySelectorAll('[data-pbd-thumb]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();const gallery=root.querySelector('.pbd-digital__images');const slide=gallery.children[Number(link.dataset.pbdThumb)];if(slide)gallery.scrollTo({left:slide.offsetLeft-gallery.children[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));}
function removePbdDeliveryEstimate(){if(document.querySelector('[data-pbd-digital]'))document.querySelectorAll('.ot-estimated-shipping').forEach(node=>node.remove());}
removePbdDeliveryEstimate();if(document.querySelector('[data-pbd-digital]'))new MutationObserver(removePbdDeliveryEstimate).observe(document.body,{childList:true,subtree:true});
document.querySelectorAll('[data-pbd-digital]').forEach(initPbdDigital);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-pbd-digital]').forEach(initPbdDigital));

  } catch(e) { console.error(e); }
})();
})();
